import React from "react";

import Skeleton from "@mui/material/Skeleton";

interface Props {
  value: string | number | undefined | null;
  loading: boolean;
  error: boolean;
  height: number | string;
  width: number | string;
  prefix?: React.ReactNode;
}

export function LoadingOrValue({
  value,
  loading,
  error,
  height,
  width,
  prefix,
}: Props) {
  if (loading)
    return <Skeleton height={height} width={width} variant="rectangular" />;

  if (error || !value) return <span>Unknown</span>;

  return (
    <span>
      {prefix ?? ""}
      {value}
    </span>
  );
}
